import styles from './Header.module.css'
import { useGetSelfQuery } from '../../../../../redux/services/TraderApi'
import React from 'react'
import formatNumber from '../../../../../utils/functions/formatNumber'
import { Loading } from '../../../../../components/Loading/Loading'
import { useGetDashboardQuery } from '../../../../../redux/services/TraderApi'

type RateProps = {
  page?: 'withdrawal' | 'orders'
}

const DepositRates = () => {
  const { data, isLoading } = useGetDashboardQuery(undefined, { pollingInterval: 10000 })
  if (isLoading) return <Loading />

  return (
    <div className={`${styles.wrapper} ${styles.currencyRates}`} aria-label='Курсы валют пополнений'>
      <span className={styles.ratesTitle}>Курсы пополнений</span>
      {data?.currencies.map((currency) => (
        <div className={styles.ratePill} key={currency.code}>
          <span>USDT → {currency.code}</span>
          <strong>{currency.rate ? formatNumber(Number(currency.rate)) : '—'}</strong>
          <small>+{formatNumber(Number(currency.percent))}%</small>
        </div>
      ))}
    </div>
  )
}

const WithdrawalRate = () => {
  const { data: trader, isLoading: TraderLoading } = useGetSelfQuery(undefined, {
    pollingInterval: 10000,
  })
  if (TraderLoading) {
    return <Loading />
  }
  return (
    <div className={styles.wrapper}>
      <div className={styles.block}>
        USDT-{trader?.currency}:
        <div className={styles.item}>{formatNumber(Number(trader?.course))}</div>
      </div>
      <div className={styles.block}>
        Ваша ставка:
        <div className={styles.item}>
          <p style={{color : "#4DB84B"}}>
            <img src={'/greenArrowIcon.svg'} alt={'down arrow'} />
            {trader?.income_course} ({trader?.percent}%)
          </p>
          <p style={{color : "#FE5B37"}}>
            <img src={'/redArrowIcon.svg'} alt={'up arrow'} />
            {trader?.outcome_course} ({trader?.outcome_percent}%)
          </p>
        </div>
      </div>
    </div>
  )
}

export const Rate = ({ page = 'withdrawal' }: RateProps) => (
  page === 'orders' ? <DepositRates /> : <WithdrawalRate />
)
